import PassTypes from "./PassTypes";
import './passTypes.scss';

export default PassTypes;